import { DateTime } from 'luxon';
import { hasDropPenalty, isUndroppable, opportunityLocksBeforeStartTime } from '@amzn/atoz-shiftapp-utilities';
export var getOpportunityDetails = function (shiftOpportunity) {
    var dropDeadline = shiftOpportunity.dropDeadline, penaltyStartTime = shiftOpportunity.penaltyStartTime, _a = shiftOpportunity.shift.timeRange, start = _a.start, end = _a.end, eligibility = shiftOpportunity.eligibility;
    var shiftEndTime = DateTime.fromISO(end);
    var penaltyStartDateTime = penaltyStartTime
        ? DateTime.fromISO(penaltyStartTime)
        : null;
    return {
        isEligible: (eligibility === null || eligibility === void 0 ? void 0 : eligibility.isEligible) === true,
        unclaimableReasonCodes: (eligibility === null || eligibility === void 0 ? void 0 : eligibility.unclaimableReasonCodes) || [],
        isUndroppable: isUndroppable(dropDeadline),
        hasDropPenalty: hasDropPenalty({
            shiftEndTime: shiftEndTime,
            penaltyStartTime: penaltyStartDateTime
        }),
        dropDeadline: dropDeadline ? DateTime.fromISO(dropDeadline) : null,
        locksBeforeStart: opportunityLocksBeforeStartTime(start, dropDeadline)
    };
};
